import React, { useState } from 'react';
import styled from 'styled-components';
import AgeConfirmation from '../components/age-confirmation';
import Boxes from '../assets/images/bbb-boxes.png';
import BoxImages from '../components/box-images';
import ImageGallery from '../components/image-gallery';
import AboutNyrundum from '../components/about-nyrundum';
import MapImages from '../components/map-images';

const Home = (): JSX.Element => {
  const [ageConfirmed, setAgeConfirmed] = useState(false);

  return (
    <HomeContainer>
      {!ageConfirmed && <AgeConfirmation setAgeConfirmed={setAgeConfirmed} />}
      {ageConfirmed && (
        <HomeContentWrapper>
          <BoxImages />
          <ImageGallery />
          <AboutNyrundum />
          <MapImages />
        </HomeContentWrapper>
      )}
    </HomeContainer>
  );
};

export default Home;

const HomeContainer = styled.div`
  background-image: url(${Boxes});
  background-size: cover;
  background-position: calc(100% - 55%) center;
  display: flex;
  height: 100%;
  width: 100%;
  font-family: Optima;
  overflow: scroll;
`;

const HomeContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 45vh auto auto auto;
  grid-template-columns: 100vw;

  @media (min-width: 769px) {
    grid-template-rows: 54rem auto auto;
  }
`;
